// Copyright (c) 2021 Deere & Company

import AuthenticatedPage from '../../common/components/authenticated-page';
import OF87BatchSubstitution from './batchSubstitution';
import React from 'react';

function OF87BatchSubstitutionPage () {

    return (
        <AuthenticatedPage className="atp-page atp-batch-substitution-page">
            <OF87BatchSubstitution />
        </AuthenticatedPage>
    );

}
OF87BatchSubstitutionPage.displayNAme = 'OF87BatchSubstitutionPage';

export default OF87BatchSubstitutionPage;
